module.exports = __webpack_public_path__ + "img/video-icon.30404b93.svg";